import type { BackendAPITypes } from '../../../../../../../generated/blueprint.ts';
import type { GlAccount } from '../../../../../../../hooks/useGLAccounts.ts';
import type { Subledger } from '../../../../../../../components/specific/SubledgerSelector';
import { toCentsFromMoney, type Money } from '../../../../../../../lib/Money.ts';

export type FixedAssetFormValues = {
    name: string;
    purchase_date: string;
    economic_lifetime_months: number | '' | undefined;
    purchase_money: Money | null;
    residual_money: Money | null;
    balance_sheet_gl_account: GlAccount | null;
    profit_and_loss_gl_account: GlAccount | null;
    subledger: Subledger | null;
};

export type CreateFixedAssetBody = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerCreateFixedAssetPostRequestBody;

export type FixedAssetBillLink = {
    documentId: string;
    expectedBillVersion: number | null;
};

export function mapFixedAssetFormToApiBody(
    clientBusinessId: string,
    values: FixedAssetFormValues,
    billLink: FixedAssetBillLink | null = null,
): CreateFixedAssetBody {
    return {
        client_business_id: clientBusinessId,
        name: values.name,
        purchase_date: values.purchase_date,
        purchase_value_cents: toCentsFromMoney(values.purchase_money!),
        residual_value_cents:
            values.residual_money !== null ? toCentsFromMoney(values.residual_money) : 0,
        economic_lifetime_months: Number(values.economic_lifetime_months),
        balance_sheet_gl_account_id: values.balance_sheet_gl_account!.id,
        profit_and_loss_gl_account_id: values.profit_and_loss_gl_account!.id,
        subledger_id: values.subledger?.id ?? null,
        document_id: billLink?.documentId ?? null,
        expected_bill_version: billLink?.expectedBillVersion ?? null,
    };
}
